import styled from 'styled-components';

export const MobileAccountBlockStyled = styled.div`
    &.scrolled {
        .top-box {
            top: 0;
        }
    }

    .sum-pl {
        background: rgba(129, 146, 228, 0.1);
        border-radius: 12px;
        padding: 6px 12px;

        font-weight: 600;
        display: inline-block;
    }

    .pl-diff {
        svg {
            margin-left: 8px;
            margin-right: -4px;
        }
    }

    .pl-diff-period {
        color: var(--color-secondary);
        font-size: 14px;
        line-height: 20px;
        margin: 0 8px;
    }

`;

export const MobileAccountTopBoxStyled = styled.div`
    background-color: var(--color-surface);
    position: fixed;
    top: -100px;
    left: 0;
    right: 0;
    padding: 16px;
    text-align: center;
    z-index: 3;
    width: 100%;
    box-shadow: 0 0 25px rgb(0 0 0 / 25%);
    transition: all 0.5s ease-in-out;

    .equity {
        font-weight: 700;
        font-size: 16px;
    }
`;

export const MobileAccountStatButtonStyled = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    padding: 12px;

    .btn {
        padding: 12px;
        border-radius: 12px;
        font-size: 16px;

        border: none;
        line-height: 1;
        
        &:hover {
            border: none;
        }
    }
`;

export const MobileAccountBoxStyled = styled.div`
    position: relative;
    background-color: var(--color-surface);
    border-radius: 16px;
    padding: 12px;

    h1 {
        padding: 0 8px;
        margin-bottom: 16px;
        font-size: 40px;
        line-height: 48px;
    }

    .buttons {
        margin-top: 16px;

        display: flex;
        flex-direction: row;
        gap: 4px;

        > * {
            flex: 1 0 calc(100% / 3 - 16px) !important;
            border-radius: 12px;
            padding: 12px 0;

            svg {
                margin-bottom: 4px;
                fill: var(--color-secondary);
                stroke: var(--color-secondary);
            }
            
            &:hover {
                background: var(--color-purple);
                border: 1px solid var(--color-purple);
            }
        }
    }
`;